import { render, staticRenderFns } from "./adverseRecord.vue?vue&type=template&id=bf8d8596&scoped=true"
import script from "./adverseRecord.vue?vue&type=script&lang=js"
export * from "./adverseRecord.vue?vue&type=script&lang=js"
import style0 from "./adverseRecord.vue?vue&type=style&index=0&id=bf8d8596&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8d8596",
  null
  
)

export default component.exports